import { render, staticRenderFns } from "./undercarriage.vue?vue&type=template&id=209373da&scoped=true&"
import script from "./undercarriage.vue?vue&type=script&lang=js&"
export * from "./undercarriage.vue?vue&type=script&lang=js&"
import style0 from "./undercarriage.vue?vue&type=style&index=0&id=209373da&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209373da",
  null
  
)

export default component.exports